var _path, _circle, _circle2, _circle3, _circle4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconStatsUnactive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 21,
    viewBox: "0 0 32 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.34302 19.2557L10.1934 10.533L18.0439 19.2557L30.2556 1.8103",
    stroke: "#968E53",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    className: "my_stat_path"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2.34305,
    cy: 19.2556,
    r: 1.74454,
    fill: "#968E53",
    className: "my_stat_circle"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.1936,
    cy: 9.66063,
    r: 2.61681,
    fill: "#968E53",
    className: "my_stat_circle"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.0439,
    cy: 19.2556,
    r: 1.74454,
    fill: "#968E53",
    className: "my_stat_circle"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.3832,
    cy: 2.68248,
    r: 2.61681,
    fill: "#968E53",
    className: "my_stat_circle"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStatsUnactive);
export default __webpack_public_path__ + "static/media/icon-stats-unactive.88d5dca5.svg";
export { ForwardRef as ReactComponent };